import { render, staticRenderFns } from "./BaseRequiredMark.vue?vue&type=template&id=2e9a43ba&scoped=true"
import script from "./BaseRequiredMark.vue?vue&type=script&lang=js"
export * from "./BaseRequiredMark.vue?vue&type=script&lang=js"
import style0 from "./BaseRequiredMark.vue?vue&type=style&index=0&id=2e9a43ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a43ba",
  null
  
)

export default component.exports